export const CONSTANTS = {
  SCREEN_GROUP: 'shipment',
  REQUEST_DETAIL: 'request-shipment-detail',
  LIST_ALL: 'list-shipment-all',
  GRID_SHIPMENT_SUPPLIER_LOOKUP_DIALOG: 'grid-shipment-supplier-lookup-dialog',
} as const;
